import React from 'react';
import { isMobile } from '@pascal/pascal-core';

export function GameTitleSection() {
  if (isMobile()) {
    return (
      <div className='inside-m-game-backside'>
        <div className='inner-inside-m-game-backside'>
          <h3 className='m-blackjack-table-name'>BlackJack</h3>
          <div className='m-blackjack-table-type'>
            <p className='m-blackjack-table-type-txt'>pays 3 to 2</p>
          </div>
          <p className='m-blackjack-table-info-text'>
            Dealer must stand on 17, six player cards = win
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className='blackjack-table-info'>
      <div className='blackjack-table-info-content'>
        <h3 className='blackjack-table-name'>blackjack</h3>
        <p className='blackjack-table-type'>pays 3 to 2</p>
        <p className='blackjack-table-info-text'>Dealer must stand on 17, six player cards = win</p>
      </div>
    </div>
  );
}
